export const getKeyValidationMessage = (key) => {
    if (/^(?![A-Za-z0-9_-]+$)/.test(key)) {
        return "Only a-z, A-Z, 0-9, '-' and '_' are allowed.";
    }
    return undefined;
};
export const thisFieldIsEmptyMessage = 'This field should not be empty.';
export const getEmptyInputMessage = (value) => {
    if (value === '') {
        return thisFieldIsEmptyMessage;
    }
    return undefined;
};
export const getAuthorizationKeyMessage = (value) => {
    if (value.toLowerCase() === 'authorization') {
        return "'Authorization' is not allowed as key. Please use the field above.";
    }
    return undefined;
};
export const isValidateCustomHeaders = (customHeader) => customHeader &&
    (Object.keys(customHeader).some((key) => getKeyValidationMessage(key)) ||
        Object.keys(customHeader).some((key) => getAuthorizationKeyMessage(key)) ||
        Object.values(customHeader).some((value) => getEmptyInputMessage(value)))
    ? false
    : undefined;
